{
  "memberGroupProfile.removeFromGroup.error": "グループからメンバーを削除しようとしているときに問題が発生しました。",
  "memberGroupProfile.updateGroupPoints.error": "グループポイントの更新中に問題が発生しました。",
  "memberGroupProfile.updateGroupTier.error": "グループ会員層の更新中に問題が発生しました。",
  "memberGroupProfile.removeFromGroup.deleteDialog.title": "グループからこのメンバー <br /> を削除しますか?",
  "memberGroupProfile.sperator.members": "メンバー",
  "memberGroupProfile.sperator.activity": "アクティビティ",
  "memberGroupProfile.title": "グループプロファイル",
  "memberGroupProfile.headerTitle": "グループ ID: {groupId}",
  "memberGroupProfile.updateTierBtn.label": "会員層の更新",
  "memberGroupProfile.addNewMembersBtn.label": "メンバーの追加",
  "memberGroupProfile.notification": "メンバーのプロファイルに対するすべての更新が確認できるまで最大で 24 時間かかる場合があります。",
  "memberProfile.updateMembeerPoints.error": "メンバーポイントの更新中に問題が発生しました。もう一度実行してください。",
  "memberProfile.updateMemberTier.error": "メンバー会員層の更新中に問題が発生しました。もう一度実行してください。",
  "memberProfile.updateMemberPlan.error": "メンバープランの更新中に問題が発生しました。もう一度実行してください。",
  "memberProfile.updateMemberAdditionalBenefits.error": "メンバー会員特典の更新中に問題が発生しました。もう一度実行してください。",
  "memberProfile.title": "メンバープロファイル",
  "memberProfile.headerTitle": "メンバー ID: {memberId}",
  "memberProfile.updateTierBtn.label": "会員層の更新",
  "memberProfile.updatePlanBtn.label": "プランの移行",
  "memberProfile.updatePlanBtn.tootip": "グループに属しているメンバーは移行できません。",
  "memberProfile.updateBenefitsBtn.label": "会員特典の更新",
  "memberProfile.notification": "メンバーのプロファイルに対するすべての更新が確認できるまで最大で 24 時間かかる場合があります。",
  "memberProfile.activity.title": "アクティビティ",
  "memberProfile.activity.downloadBtn.label": "バウチャーレポートのダウンロード",
  "memberProfile.activity.downloadBtn.tooltip": "CSV 形式のメンバーバウチャーレポートをダウンロードします。",
  "memberProfile.activity.pagination.pageSize": "{input} 行表示",
  "memberProfile.activity.pagination.recordsDisplayed": "{total} の {start} - {end}",
  "memberProfile.duplicateAlert": "このメンバー ID に複数のコンタクトが見つかったため、個人データを表示できません。",
  "memberProfileOverview.groupProfileBtn.tooltip": "グループプロファイル",
  "memberProfileOverview.search.error": "検索中に問題が発生しました。もう一度検索を実行してください。",
  "memberProfileOverview.search.noResults.lead": "検索に一致する結果がありません。検索基準を変更してもう一度検索を実行してください。",
  "memberProfileOverview.search.noItems.title": "検索に一致する結果がありません。",
  "memberProfileOverview.search.noResults.title": "検索に一致する結果がありません。",
  "memberProfileOverview.deleteMemberIcon.tooltip": "メンバーを削除します",
  "memberProfileOverview.deleteMemberDialog.headline": "メンバーの削除",
  "memberProfileOverview.deleteMemberDialog.notification": "このメンバーを削除すると、ロイヤリティメンバーシップが完全にキャンセルされます。このアクションを取り消すことはできません。メンバーデータはシステムに保存されます。",
  "memberProfileOverview.deleteMemberDialog.memberToBeDeleted": "削除するメンバー",
  "memberProfileOverview.deleteMemberDialog.checkboxText": "レポートデータベースからすべてのロイヤリティデータを削除する。",
  "memberProfileOverview.deleteMemberDialog.deleteButton": "削除",
  "memberProfileOverview.deleteMember.error": "このメンバーの削除中に問題が発生しました。 ",
  "memberProfileOverview.deleteGroupDialog.headline": "このグループを削除しますか?",
  "memberProfileOverview.deleteGroupDialog.content": "このグループを削除すると、すべてのロイヤリティデータが完全に削除されます。",
  "memberProfileOverview.deleteGroup.error": "このグループの削除中に問題が発生しました。",
  "memberProfileOverview.deleteGroup.success": "グループが削除されました。",
  "memberProfileOverview.tableHeader.memberID": "メンバー ID",
  "memberProfileOverview.tableHeader.tier": "会員層",
  "memberProfileOverview.tableHeader.pointsToSpend": "利用ポイント",
  "memberProfileOverview.tableHeader.joinDate": "入会日",
  "memberProfileOverveiw.memberTable.delete.label": "メンバーの削除",
  "memberProfileOverview.groupTableHeader.groupId": "グループ ID",
  "memberProfileOverview.groupTableHeader.tier": "会員層",
  "memberProfileOverview.groupTableHeader.points": "ステータスポイント",
  "memberProfileOverview.groupTableHeader.members": "グループメンバー",
  "memberProfileOverview.groupTableHeader.created": "作成済み",
  "memberProfileOverveiw.groupTable.delete.label": "グループの削除",
  "memberProfileOverveiw.grid.search.tooltip.groupEnabled": "ID でメンバーおよびグループを検索します",
  "memberProfileOverveiw.grid.search.tooltip": "外部 ID でメンバーを検索します",
  "memberProfileOverveiw.grid.search.label": "検索",
  "memberProfileOverveiw.grid.btnCreateNewMember.label": "メンバーの作成",
  "memberProfileOverveiw.grid.btnCreateNewGroup.label": "メンバーグループの作成",
  "memberProfileOverveiw.grid.support.title": "ロイヤリティサポート",
  "memberProfileOverveiw.grid.title": "メンバープロファイル",
  "activityType.online_purchase.name": "購入",
  "activityType.redemption.name": "ロイヤリティオファー",
  "activityType.exclusive_redemption.name": "ポイントのアクセス",
  "activityType.customer_support.tierUpgrade.name": "会員層アップグレード",
  "activityType.customer_support.tierDowngrade.name": "会員層ダウングレード",
  "activityType.customer_support.cashbackAdded.name": "キャッシュバックの追加",
  "activityType.customer_support.pointsAdded.name": "{{points_name}} の追加",
  "activityType.customer_support.planChange.name": "{planName}/{planId} への移行",
  "activityType.points_expiration.status.name": "ステータス {{points_name}} の期限切れ",
  "activityType.points_expiration.cachback.name": "キャッシュバックの期限切れ",
  "activityType.tier_calculation.name": "会員層の計算",
  "activityType.group_create.name": "グループの作成",
  "activityType.group_calculation.name": "グループの計算 ",
  "activityType.group_calculation.joinMember.name": "グループへのメンバーの入会",
  "activityType.group_calculation.leftMember.name": "グループからのメンバーの退会",
  "activityType.group_calculation.noChange.name": "グループアクティビティ",
  "activityType.group_delete.name": "グループの閉鎖",
  "activityType.additional_benefits.added.name": "追加会員特典の追加",
  "activityType.additional_benefits.removed.name": "追加会員特典の削除",
  "activityType.member_joined.name": "ロイヤリティへの入会",
  "activityType.points_migrated.name": "移行",
  "groupActivity": "グループアクティビティ",
  "activityElementType.purchase_points.negative": "返品のためのポイントの削除",
  "activityElementType.purchase_points.positive.fromCatalog": "カタログからの購入",
  "activityElementType.purchase_points.positive.fromOnline": "購入",
  "activityElementType.byCustomerSupport": "カスタマサポート",
  "activityElementType.tierChange": "会員層の変更",
  "activityElementType.redemption_points": "ポイントの引き換え",
  "activityElementType.redemption_points.voucherRedemptionPoints": "ポイントのバウチャー",
  "activityElementType.redemption_points.exclusiveRedemptionPoints": "ポイントのアクセス",
  "activityElementType.redemption_points.voucherRedemptionCashback": "キャッシュバックとしてのバウチャー",
  "activityElementType.redemption_free": "無料の引き換え",
  "activityElementType.redemption_free.voucher": "無料のバウチャー",
  "activityElementType.redemption_free.exclusive": "無料のアクセス",
  "activityElementType.support_plan_change": "プランの移行",
  "activityElementType.plan_change_points": "ポイントの移行",
  "activityElementType.plan_change_voucher": "特典の移行",
  "activityElementType.contact_state.joinedGroup": "グループへのメンバーの入会",
  "activityElementType.contact_state.leftGroup.allGroupActivity": "グループからのメンバーの退会",
  "activityElementType.contact_state.leftGroup.onlyMemberLeft": "共有ポイントの配分",
  "rewardName.cashback": "キャッシュバック",
  "rewardName.tier": "会員層",
  "rewardName.pointsAdditional": "追加 {{points_name}}",
  "rewardName.pointsBasic": "基本 {{points_name}}",
  "rewardName.pointsExtra": "特別 {{points_name}}",
  "rewardName.pointsBonus": "ボーナス {{points_name}}",
  "rewardName.statusUpgrade": "アップグレードされたステータス",
  "rewardName.voucher": "バウチャー",
  "rewardName.exclusiveAccess": "会員限定アクセス",
  "error.externalIdError.required": "外部 ID を入力してください",
  "error.externalIdError.exists": "このコンタクトはすでにロイヤリティメンバーです。",
  "error.failToCreateMember": "このメンバーの作成中に問題が発生しました。",
  "error.groupNameAlreadyExist": "この名前はすでに存在します。一意の名前を入力してください。",
  "error.groupNameAlreadyExist.WithName": "このグループ名 {groupName} はすでに存在します。一意の名前を入力してください。",
  "error.failedToCreateGroup": "このグループの作成中に問題が発生しました。",
  "error.failedToAddMembersToGroup": "グループへのメンバーの追加中に問題が発生しました。",
  "createContactPopup.title": "メンバーの作成",
  "createContactPopup.notification": "新規メンバーは、ロイヤリティ管理設定のメンバーシップ設定に基づいて会員層に割り当てられます。",
  "createContactPopup.multiPlanSelect.label": "プランの選択",
  "createContactPopup.multiPlanSelect.tooltip": "新規メンバーが入会するプログラムを選択します。",
  "createContactPopup.externalId.tooltip": "新規ロイヤリティメンバーを追加するには、販売データで使用したのと同じ外部 ID を入力してください。",
  "createContactPopup.externalId.label": "外部 ID の入力",
  "success.createGroup": "グループが作成されました。",
  "success.addMembersToGroup": "メンバーがグループに追加されました。",
  "createGroupPopup.saveBtn.disabled.tooltip.create": "グループを作成するには、少なくとも 2 人のメンバーをグループに追加する必要があります。",
  "createGroupPopup.saveBtn.disabled.tooltip.modify": "少なくとも 1 人のメンバーを追加します。",
  "createGroupPopup.saveBtn.disabled.tooltip.create.nameMissing": "グループ名を入力します。",
  "createGroupPopup.title.create": "メンバーグループの作成",
  "createGroupPopup.title.modify": "メンバーの追加",
  "createGroupPopup.notification": "グループを作成するには、少なくとも 2 人のメンバーをグループに追加する必要があります。メンバーがすでにグループに属している場合、そのメンバーは検索結果に表示されません。",
  "createGroupPopup.selectPlan.label": "プランの選択",
  "createGroupPopup.selectPlan.tooltip": "異なるプランのメンバーを同じグループに追加することはできません。",
  "createGroupPopup.groupName.tooltip": "グループ識別子に対して一意の名前を作成します。グループを作成した後にこの名前を変更または複製することはできません。",
  "createGroupPopup.groupName.label": "グループ名",
  "createGroupPopup.addMembers.label": "メンバーの追加",
  "createGroupPopup.addMembers.tooltip": "外部 ID でメンバーを検索し、グループに追加します。",
  "groupMemebersTable.header.dateAdded": "追加日付",
  "groupMemebersTable.header.lastActivityDate": "最後のアクティビティ",
  "groupMemebersTable.header.removeFromGroup": "グループから削除",
  "groupProfileActivity.header.activity": "アクティビティ",
  "groupProfileActivity.header.tierExpiration": "会員層有効期限",
  "groupProfileActivity.header.reward": "特典",
  "groupProfileActivity.header.value": "値",
  "groupProfileActivity.header.expiration": "有効期限",
  "groupProfileActivity.header.orderId": "受注 ID",
  "groupProfileActivity.header.time": "時刻",
  "groupProfileActivity.header.admin": "管理者",
  "groupProfileActivity.header.status": "ステータス",
  "groupProfileActivity.search.tooltip": "日付、アクティビティ、またはステータスで検索します。",
  "groupProfileActivity.header.totalPoints": "合計ポイント",
  "groupProfileActivity.header.totalLoyaltyCredit": "合計ロイヤリティクレジット",
  "groupProfileActivity.header.activityType": "アクティビティタイプ",
  "memberProfileActivity.search.tooltip": "日付、アクティビティ、受注 ID、またはステータスで検索します。",
  "memberProfileAdditionalBenefitsPopup.title": "会員特典の更新",
  "error.failToLoadData": "データのロード中に問題が発生しました。",
  "memberProfileAdditionalBenefitsPopup.notification": "メンバーシッププロファイルまたはロイヤリティ API で追加の会員特典を管理することができます。",
  "memberProfileAdditionalBenefitsPopup.selectedBenefitIds.label": "会員特典の選択",
  "memberProfileAdditionalBenefitsPopup.selectedBenefitIds.tooltip": "このメンバーに対して更新する会員特典を選択します。更新を保存すると、その会員特典がメンバーに対して利用可能になります。公開コード付きの引き換え済み会員特典をメンバーが保有している場合、その会員特典はメンバーのウォレットに保持されます。",
  "memberProfileAdditionalBenefitsPopup.reason.tooltip": "内部追跡目的の理由を入力します。",
  "memberProfileAdditionalBenefitsPopup.reason.label": "理由",
  "memberProfileAdditionalBenefitsPopup.confirmCb.label": "これらの更新がメンバーの会員特典に影響を与えることを理解しました。",
  "memberProfileChangePlanPopup.title": "プランの移行 ",
  "memberProfileChangePlanPopup.selectedPlan.label": "プランの選択",
  "memberProfileChangePlanPopup.selectRewards.label": "移行する特典を選択",
  "memberProfileChangePlanPopup.selectRewards.tooltip": "新しいプランに移行する特典を選択します。特典を選択しないと、メンバーは、ポイントまたはバウチャーなしで最も低い会員層から新しいプランを開始します。",
  "memberProfileChangePlanPopup.selectRewards.statusPointsCb.tooltip": "メンバーは、ステータスポイントおよび新しいプランの会員層設定に基づいて会員層に割り当てられます。",
  "memberProfileChangePlanPopup.selectRewards.statusPointsCb.label": "ステータス {{points_name}}",
  "memberProfileChangePlanPopup.selectRewards.balancePointsCb.label": "残高 {{points_name}}",
  "memberProfileChangePlanPopup.selectRewards.balancePointsCb.tooltip": "ポイント有効期間は、新しいプランの設定に基づいてリセットされ、再開されます。",
  "memberProfileChangePlanPopup.selectRewards.pendingPointsCb.label": "保留中の {{points_name}}",
  "memberProfileChangePlanPopup.selectRewards.pendingPointsCb.tooltip": "保留中のポイントは、自動的に承認され、ステータスおよび残高ポイントに追加されます。",
  "memberProfileChangePlanPopup.selectRewards.redeemedVouchersCb.tooltip": "引き換え済みのバウチャーは、ロイヤリティウォレット/API にある公開コード付きのバウチャーです。固定会員特典の複数回利用可能なバウチャーは、引き換え済みであっても移行されません。",
  "memberProfileChangePlanPopup.selectRewards.redeemedVouchersCb.label": "引き換え済みのバウチャー",
  "memberProfileChangePlanPopup.migrationConfirmation.label": "移行の確認",
  "memberProfileChangePlanPopup.migrationConfirmationCb.label": "このメンバーを新しいプランに移行すると、現在のプランのメンバーシップおよびアクティビティがキャンセルされます。",
  "memberProfileDetails.tierDetails.plan": "プラン識別子: {planId}",
  "memberProfileDetails.tierDetails.group": "グループ名: {groupName}",
  "memberProfileDetails.tierDetails.joinedOn": "入会日: ",
  "memberProfileDetails.tierDetails.createdOn": "作成日:",
  "memberProfileDetails.tierDetails.groupMembers": "グループメンバー: {groupMembersNum}",
  "memberProfileDetails.tierDetails.personalInfo.firstName": "名: {firstName}",
  "memberProfileDetails.tierDetails.personalInfo.lastName": "姓: {lastName}",
  "memberProfileDetails.tierDetails.personalInfo.email": "メール: {email}",
  "memberProfileDetails.tierDetails.tierEntryDate": "会員層への登録日",
  "memberProfileDetails.tierDetails.nextTierRequirements": "次の会員層要件",
  "memberProfileDetails.pointsHistory.currentBalance.title": "現在の残高",
  "memberProfileDetails.pointsHistory.currentBalance.pointsToSpend": "利用する {{points_name}}",
  "memberProfileDetails.pointsHistory.currentBalance.expiresSoon": "まもなく期限切れ",
  "memberProfileDetails.pointsHistory.currentBalance.groupStatus": "グループのステータス {{points_name}}",
  "memberProfileDetails.pointsHistory.currentBalance.groupPending": "グループの保留中の {{points_name}}",
  "memberProfileUpdatePointsPopup.add.points.label": "{{points_name}} の追加",
  "memberProfileUpdatePointsPopup.remove.points.label": "{{points_name}} の削除",
  "memberProfileUpdatePointsPopup.remove.spend.label": "残高から削除",
  "memberProfileUpdatePointsPopup.add.spend.label": "残高に追加",
  "memberProfileUpdatePointsPopup.title.spend": "残高の更新",
  "memberProfileUpdatePointsPopup.title.points": "ポイントの更新",
  "memberProfileUpdatePointsPopup.pointsType.spend": "残高タイプ",
  "memberProfileUpdatePointsPopup.pointsType.points": "ポイントタイプ",
  "memberProfileUpdatePointsPopup.reason.tooltip": "内部追跡目的の更新理由を入力します。",
  "memberProfileUpdatePointsPopup.description.tooltip": "必要に応じて、更新の理由を入力することができます。これにより、メンバーがアクティビティ履歴でその理由を確認することができます。",
  "memberProfileUpdateTierPopup.options.invitationOnly": "{tierName} [招待者限定]",
  "memberProfileUpdateTierPopup.title": "会員層の更新",
  "memberProfileUpdateTierPopup.notification": "メンバーを会員層に割り当てると、メンバーは固定会員特典の権利が付与され、会員層設定の計算で定義された期間にわたってステータスを維持します。",
  "memberProfileUpdateTierPopup.selectTier.placeholder": "-- 会員層の選択 --",
  "memberProfileUpdateTierPopup.reason.tooltip": "内部追跡目的のために、次のアクションの理由を入力してください: {text}",
  "memberProfileUpdateTierPopup.confirmCb.label": "これらの更新が {text} メンバーのロイヤリティステータスに影響を与えることを理解しました。",
  "tierDowngrade.points.options.status.name": "現在のポイントに従った会員層にメンバーをダウングレードする。",
  "tierDowngrade.points.options.tier.name": "特定の会員層にメンバーをダウングレードする。",
  "tierDowngrade.points.options.tier.tooltip": "ステータスポイントは、この会員層に必要な最小値に更新されます。",
  "tierDowngrade.spend.options.status.name": "現在のロイヤリティクレジットに従った会員層にメンバーをダウングレードする。",
  "tierDowngrade.spend.options.tier.name": "特定の会員層にメンバーをダウングレードする。",
  "tierDowngrade.spend.options.tier.tooltip": "ロイヤリティクレジットは、この会員層に必要な最小値に更新されます。",
  "tierUpdate.options.tierUpgrade.name": "会員層のアップグレード",
  "tierUpdate.options.tierDowngrade.name": "会員層のダウングレード",
  "membersReportDownloadButton.tooltip": "メンバーステータスレポートは、メンバーのロイヤリティステータス情報を含む CSV ファイルです。ダウンロードには数分かかる場合があります。",
  "membersReportDownloadButton.label": "メンバーステータスレポートのダウンロード",
  "updatePointsType.points.options.loyalty": "ロイヤリティ {{points_name}} (ステータス {{points_name}} と利用 {{points_name}})",
  "updatePointsType.points.options.status": "ステータス {{points_name}} のみ",
  "updatePointsType.points.options.spend": "利用 {{points_name}} のみ",
  "updatePointsType.spend.options.status": "ステータス {{points_name}} のみ",
  "updatePointsType.spend.options.cashback": "キャッシュバックのみ",
  "memberPointsUpdateValidator.confirmed.isTrue": "必要なすべての情報を入力していることを確認してください。",
  "memberPointsUpdateValidator.reason.presence": "内部追跡目的の理由を入力してください。",
  "memberPointsUpdateValidator.pointsValue.presence": "ポイントの数にはゼロより大きい数値を入力してください。",
  "memberPointsUpdateValidator.pointsValue.numericality.notInteger": "ポイントの数にはゼロより大きい数値を入力してください。",
  "memberPointsUpdateValidator.pointsValue.numericality.notGreaterThan": "ポイントにはゼロより大きい数値を入力してください。",
  "memberPointsUpdateValidator.pointsValue.numericality.notLessThan": "ポイントは 100,000 未満として入力してください。",
  "memberPointsUpdateValidator.pointsValue.minPointsForRemove.messageLoyaltyPoints": "削除するポイントの数は、既存のポイント数を上回ることはできません。",
  "memberPointsUpdateValidator.pointsValue.minPointsForRemove.message": "削除するポイントの数は、既存のポイント数を上回ることはできません。",
  "memberPointsUpdateValidator.pointsValue.minSumForRemove.message": "削除するポイントの数は、メンバーが現在保有しているポイントを上回ることはできません。",
  "memberPointsUpdateValidator.pointsValue.minSumForRemove.messageCashback": "削除するキャッシュバックの数は、既存のキャッシュバック金額を上回ることはできません。",
  "memberTierUpdateValidator.tierDowngradeType": "ダウングレードタイプを選択してください。",
  "memberTierUpdateValidator.selectedTierId": "会員層を選択してください。",
  "memberGroupProfile.removeFromGroup.deleteDialog.content.status": "このメンバーを削除すると、累計ステータスポイントがグループステータスから削除されます。",
  "memberGroupProfile.removeFromGroup.deleteDialog.content.loyality": "このメンバーを削除すると、累計ロイヤリティクレジットがグループステータスから削除されます。",
  "memberGroupProfile.updatePointsBtn.label.points": "ポイントの更新",
  "memberGroupProfile.updatePointsBtn.label.balance": "残高の更新",
  "memberProfile.updatePointsBtn.label.points": "ポイントの更新",
  "memberProfile.updatePointsBtn.label.balance": "残高の更新",
  "memberGroupProfile.removeFromGroup.deleteDialog.content": "このメンバーを削除すると、累計された {pointType} がグループステータスから削除されます。",
  "memberGroupProfile.updatePointsBtn.label": "更新 {isPoints,select,true {Points} other {Balance}}",
  "memberProfile.updatePointsBtn.label": "更新 {isPoints,select,true {Points} other {Balance}}",
  "activityType.customer_support.cashbackRemoved.name": "キャッシュバックを削除しました ",
  "activityType.customer_support.pointsRemoved.name": "削除しました {{points_name}}",
  "activityType.points_expiration.toSpend.name": "期限切れの残高 {{points_name}}",
  "memberProfileUpdatePointsPopup.confirmed.label": "これらの更新が {text} メンバーのロイヤリティステータスに影響を与えることを理解しました。"
}
